import React from 'react'
import { LandingPageForm } from '..'

export default function MBASpecialise() {
  const formParams = {
         division: "ISEG MCS",
         school: "ISEG MCS",
         firstNameRequired: true,
         lastNameRequired: true,
         emailRequired: true,
         phoneNumberRequired: true,
         academicLevelRequired: true,
         campusRequired: true,
         lastForm: "Autre",
         leadSource: "Autre",
         formId: "DOC",
         status: "Nouveau",
         description: "",
         subject: "",
         theme: "",
         form: "Autre",
         recordTypeName: "BusinessSchoolLead",
         campuses: [
             "Paris",
             "Bordeaux",
             "Lille",
             "Lyon",
             "Nantes",
             "Nice",
             "Strasbourg",
             "Toulouse",
         ],
         academics: [
             "Terminale (BAC)",
             "BAC",
             "Bac +1",
             "Bac +2",
             "Bac +3",
             "Bac +4",
             "Bac +5",
             "Autre",
         ],
         color: "#1f387b",
         backgroundColor: "#e8ebf2",
         hover: "#1f387b",
         postalCode: true,
         formationRequired: false,
         presentielRequired: false,
         consentRequired: false,
         legalRequired: true,
         salutationRequired: true,
         redirectUrl:
             "https://isegcom.fr/bachelor-communication/retour-documentation/",
         isMultiCampus: false,
         contactConsent: true,
         textColor: "#1f387b",
         buttonColor: "#1f387b",
         buttonTextColor: "#ffffff",
         campMemberStatus: "Requested",
     };
 
     return <LandingPageForm params={JSON.stringify(formParams)} />;
}
